/* eslint-disable jsx-a11y/iframe-has-title */
import React from 'react';
import LightBox from '../../lightbox/lightbox';
import './css/services.css';

const Services = () => {
    return (
        <div>
           <div className="bg-gallery">
                <h1><span>G</span>allery</h1>
                <h5>what to know before you visit</h5>
                <p>let's reconnect with gallery</p>
           </div>
           <div className="gallery-heading-image">
               <h1>images</h1>
           </div>
           <LightBox />
           <div className="gallery-heading-video">
                <h1>videos</h1>
                <div className="gallery-video-main">
                    <div className="video-content-one">
                    <iframe width="100%" height="240px"
                     src="https://www.youtube.com/embed/dtqYYVZWw3s"
                     frameBorder="0" className="video-common"></iframe>
                    </div>
                    <div className="video-content-two">
                    <iframe width="100%" height="240px" 
                    src="https://www.youtube.com/embed/QLcYekD3BFs" 
                    frameBorder="0" className="video-common"></iframe>
                    </div>
                </div>
           </div>
        </div>
    )
}

export default Services;
